import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ standalone: false, name: 'monthsToYears' })
export class MonthsToYears implements PipeTransform {
  transform(months: number) {
    let years = months/12;
    return years;
  }
}
